import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { Nav, Navbar } from '@softwaredev_cegeka/stix-core'
import { UserMenu } from 'src/components/Menu'
import { UserDataContext } from 'src/components/auth/withAuth'
import {
    catalogReadIsAllowed,
    isAllowed,
    PRODUCT_TEMPLATE_CRUD,
    USER_READ,
    productReadIsAllowed,
    RBAC_CRUD,
    MACRO_CRUD,
    ORDERS_VIEW_ALL_NON_RESTICTED_ORDERS,
} from 'src/utils/authorization'
import { reverse } from 'src/routes/config'
import logo from 'src/assets/images/catalog-logo.png'
import './header.scss'

const Header = () => {
    const context = useContext(UserDataContext)
    return (
        <Navbar fixed={'top'} sticky={'top'} bg={'primary'} variant={'dark'}>
            <NavLink to={reverse('home')}>
                <Navbar.Brand>
                    <img src={logo} alt={'logo'} className={'logo'} />
                </Navbar.Brand>
            </NavLink>
            <Nav>
                {catalogReadIsAllowed(context) ? (
                    <NavLink
                        className={'stix-nav-link'}
                        to={reverse('catalog-list')}
                    >
                        Catalogs
                    </NavLink>
                ) : null}
                {isAllowed(context, PRODUCT_TEMPLATE_CRUD) && (
                    <NavLink
                        className={'stix-nav-link'}
                        to={reverse('productTemplate-list')}
                    >
                        Product templates
                    </NavLink>
                )}
                {productReadIsAllowed(context) ? (
                    <NavLink
                        className={'stix-nav-link'}
                        to={reverse('product-list')}
                    >
                        Products
                    </NavLink>
                ) : null}
                <NavLink
                    className={'stix-nav-link'}
                    to={reverse('category-list')}
                >
                    Categories
                </NavLink>
                {isAllowed(context, USER_READ) ? (
                    <NavLink
                        className={'stix-nav-link'}
                        to={reverse('user-overview')}
                    >
                        Users
                    </NavLink>
                ) : null}
                {isAllowed(context, RBAC_CRUD) ? (
                    <NavLink
                        className={'stix-nav-link'}
                        to={reverse('group-list')}
                    >
                        Groups
                    </NavLink>
                ) : null}
                {isAllowed(context, MACRO_CRUD) ? (
                    <NavLink
                        className={'stix-nav-link'}
                        to={reverse('macro-list')}
                    >
                        Macros
                    </NavLink>
                ) : null}
                {isAllowed(context, ORDERS_VIEW_ALL_NON_RESTICTED_ORDERS) && (
                    <NavLink
                        className={'stix-nav-link'}
                        to={reverse('order-list')}
                    >
                        Orders
                    </NavLink>
                )}
            </Nav>
            <Navbar.Right>
                <UserMenu />
            </Navbar.Right>
        </Navbar>
    )
}

export default Header
